module.exports = __webpack_public_path__ + "static/media/PetrifiedForest.17b4623a.jpg";